module.exports = __webpack_public_path__ + "media/images/download-gray-3ac5d515f647b34e381f930e987ea641.svg";